module.exports = __webpack_public_path__ + "media/npc_dota_hero_crystal_maiden.cc9cffca.webm";